import { render, staticRenderFns } from "./WaitingSubscriptionModal.vue?vue&type=template&id=2c996bbb&scoped=true"
import script from "./WaitingSubscriptionModal.vue?vue&type=script&lang=ts"
export * from "./WaitingSubscriptionModal.vue?vue&type=script&lang=ts"
import style0 from "./WaitingSubscriptionModal.vue?vue&type=style&index=0&id=2c996bbb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c996bbb",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QImg,QBtn});
